module.exports = __webpack_public_path__ + "img/1591129608.0e9f23c5.jpg";